if (!customElements.get('complementary-scroll')) {
  customElements.define(
    'complementary-scroll',
    class ComplementaryScroll extends HTMLElement {
      constructor() {
        super();
        this.isPointerDown = false;
        this.hasDragged = false;
        this.startX = 0;
        this.startScrollLeft = 0;

        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onClickCapture = this.onClickCapture.bind(this);
      }

      connectedCallback() {
        this.track = this.querySelector('[data-complementary-scroll]');
        if (!this.track) return;

        this.track.addEventListener('pointerdown', this.onPointerDown);
        this.track.addEventListener('pointermove', this.onPointerMove);
        this.track.addEventListener('pointerup', this.onPointerUp);
        this.track.addEventListener('pointerleave', this.onPointerUp);
        this.track.addEventListener('pointercancel', this.onPointerUp);
        this.track.addEventListener('click', this.onClickCapture, true);
      }

      disconnectedCallback() {
        if (!this.track) return;

        this.track.removeEventListener('pointerdown', this.onPointerDown);
        this.track.removeEventListener('pointermove', this.onPointerMove);
        this.track.removeEventListener('pointerup', this.onPointerUp);
        this.track.removeEventListener('pointerleave', this.onPointerUp);
        this.track.removeEventListener('pointercancel', this.onPointerUp);
        this.track.removeEventListener('click', this.onClickCapture, true);
      }

      onPointerDown(event) {
        // Touch (and pen) already gets native momentum scrolling, like on mobile.
        // Only take over for mouse input, to add click-and-drag scrolling on desktop.
        if (event.pointerType === 'touch') return;

        this.isPointerDown = true;
        this.hasDragged = false;
        this.startX = event.clientX;
        this.startScrollLeft = this.track.scrollLeft;
        this.pointerId = event.pointerId;

        // Deliberately no preventDefault()/setPointerCapture() here: a plain click
        // (no movement) must be left alone so links still navigate normally. Those
        // only kick in once onPointerMove confirms an actual drag is happening.
      }

      onPointerMove(event) {
        if (!this.isPointerDown) return;

        const delta = event.clientX - this.startX;

        if (!this.hasDragged) {
          if (Math.abs(delta) <= 3) return;
          this.hasDragged = true;
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(this.pointerId);
        }

        // Without this, dragging over a product image or link makes the browser
        // kick off its own native image/link drag instead of letting us scroll,
        // which swallows the following pointermove events.
        event.preventDefault();
        this.track.scrollLeft = this.startScrollLeft - delta;
      }

      onPointerUp(event) {
        this.isPointerDown = false;
        this.track.classList.remove('is-dragging');
        if (this.pointerId !== undefined && this.track.hasPointerCapture?.(this.pointerId)) {
          this.track.releasePointerCapture(this.pointerId);
        }
      }

      onClickCapture(event) {
        // Prevent a drag from also registering as a click on the product card underneath it.
        if (this.hasDragged) {
          event.preventDefault();
          event.stopPropagation();
          this.hasDragged = false;
        }
      }
    }
  );
}
